'use client';

import type { Metadata } from 'next'
import './globals.css'
import { ThemeProvider } from '../lib/theme'
import { PostgresAuthProvider } from '../lib/secure-auth-postgres'
import { ThemeSync } from '../components/ThemeSync'
import { useEffect } from 'react'

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  // Définir un titre par défaut
  useEffect(() => {
    document.title = 'Admin - Podcasts Studio';
  }, []);

  return (
    <html lang="fr">
      <head>
        <title>Admin - Podcasts Studio</title>
      </head>
      <body>
        <ThemeProvider>
          <PostgresAuthProvider>
            <ThemeSync />
            {children}
          </PostgresAuthProvider>
        </ThemeProvider>
      </body>
    </html>
  )
}
